export function getHowDidYouGetUs(metaData) {
  if (
    metaData.utm_source === 'ig' ||
    metaData.utm_campaign === 'ig' ||
    metaData.utm_source === 'instagram' ||
    metaData.utm_campaign === 'instagram'
  ) {
    return 2057;
  } else if (
    metaData.utm_source === 'fb' ||
    metaData.utm_campaign === 'fb' ||
    metaData.utm_source === 'facebook' ||
    metaData.utm_campaign === 'facebook'
  ) {
    return 2017;
  } else if (metaData.utm_source === 'google') {
    return 2013;
  }
  return '';
}
export function getMetadataStorage(searchParams) {
  let metaData = JSON.parse(sessionStorage.getItem('metadata') || '{}');
  if (searchParams.get('utm_source')) {
    metaData.utm_source = searchParams.get('utm_source');
    metaData.utm_medium = searchParams.get('utm_medium');
    metaData.utm_campaign = searchParams.get('utm_campaign');
    metaData.utm_id = searchParams.get('utm_id');
    metaData.utm_term = searchParams.get('utm_term');
  }
  return metaData;
}
